import type { TodayCustodyInfo } from '@kinapp/shared';

interface CustodyCardProps {
  custody: TodayCustodyInfo;
}

export function CustodyCard({ custody }: CustodyCardProps) {
  return (
    <div className="card">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        {custody.dependentName ? `${custody.dependentName} – Custody Today` : 'Custody Today'}
      </h2>

      <div className="p-4 rounded-lg border border-primary-200 bg-primary-50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Currently with</p>
            <p className="text-lg font-semibold text-gray-900">{custody.parentName}</p>
          </div>
          <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center text-primary-700 font-bold text-lg">
            {custody.parentName.charAt(0)}
          </div>
        </div>
      </div>

      {custody.nextHandover && (
        <div className="mt-3 p-3 rounded-lg border border-gray-200 bg-gray-50">
          <p className="text-sm text-gray-600">Next handover</p>
          <p className="font-medium text-gray-900">
            {new Date(custody.nextHandover.date).toLocaleDateString('en-GB', {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
            })}
            {custody.nextHandover.handoverTime && (
              <span className="text-gray-600"> at {custody.nextHandover.handoverTime}</span>
            )}
          </p>
          <p className="text-sm text-gray-500">
            To {custody.nextHandover.toParentName}
          </p>
        </div>
      )}
    </div>
  );
}
